import { Icon } from 'vendor/material';
import { Marketplace } from '../types/TackleOffer';
import AwsLogo from './logos/AwsLogo';
import MsftLogo from './logos/MsftLogo';
import GcpLogo from './logos/GcpLogo';

const logoByMarketplace = {
  [Marketplace.Aws]: AwsLogo,
  [Marketplace.Azure]: MsftLogo,
  [Marketplace.Gcp]: GcpLogo,
};

const style = { display: 'block' };

interface MarketplaceLogoProps {
  marketplace: Marketplace;
  fontSize?: 'default' | 'inherit' | 'large' | 'medium' | 'small';
}

const MarketplaceLogo = ({
  marketplace,
  fontSize = 'large',
}: MarketplaceLogoProps) => {
  const Logo = logoByMarketplace[marketplace];

  return (
    <Icon fontSize={fontSize}>
      <Logo style={style} height="1em" width="1em" />
    </Icon>
  );
};

export default MarketplaceLogo;
